// Centro de Retos (AGI-498). bff-web proxies every endpoint straight through to
// workspace-service's challenge routes (see workspace.challengecenter.go).

import { AxiosService } from 'src/axios/axios.service';
import {
  tChallengeCenterState,
  tChallengeFeedback,
  tChallengeKey,
  tDevTriggerAction,
  tUiSignalKey,
} from './ChallengeCenter.types';

export const ChallengeCenterService = Object.freeze({
  async getChallenges(workspaceId: string): Promise<tChallengeCenterState> {
    const response = await AxiosService.get<{ data: tChallengeCenterState }>(
      `/workspace/${workspaceId}/challenges`,
      { isBFFService: true },
    );

    return response.data;
  },

  async devTrigger(
    workspaceId: string,
    action: tDevTriggerAction,
  ): Promise<tChallengeCenterState> {
    const response = await AxiosService.post<
      { action: tDevTriggerAction },
      { data: tChallengeCenterState }
    >(
      `/workspace/${workspaceId}/challenges/dev-trigger`,
      { action },
      { isBFFService: true },
    );

    return response.data;
  },

  /** Marks a mission "practicado" (guided-tour end) — SAD D14. */
  async practiced(
    workspaceId: string,
    challengeKey: tChallengeKey,
  ): Promise<tChallengeCenterState> {
    const response = await AxiosService.post<
      Record<string, never>,
      { data: tChallengeCenterState }
    >(
      `/workspace/${workspaceId}/challenges/${challengeKey}/practiced`,
      {},
      { isBFFService: true },
    );

    return response.data;
  },

  /** The day-8 answer: does the person want more challenges? */
  async feedback(
    workspaceId: string,
    feedback: tChallengeFeedback,
  ): Promise<tChallengeCenterState> {
    const response = await AxiosService.post<
      { feedback: tChallengeFeedback },
      { data: tChallengeCenterState }
    >(
      `/workspace/${workspaceId}/challenges/feedback`,
      { feedback },
      { isBFFService: true },
    );

    return response.data;
  },

  /**
   * Reports a completion the UI witnessed (the stage editor opened, Meta
   * shows the business verified). workspace-service decides whether it
   * counts: it holds the allow-list and re-checks verification itself.
   */
  async signal(
    workspaceId: string,
    challengeKey: tUiSignalKey,
  ): Promise<tChallengeCenterState> {
    const response = await AxiosService.post<
      Record<string, never>,
      { data: tChallengeCenterState }
    >(
      `/workspace/${workspaceId}/challenges/${challengeKey}/signal`,
      {},
      { isBFFService: true },
    );

    return response.data;
  },
});
